import { TransactionBlockstore, IndexBlockstore } from './transaction';
import { clockChangesSince, applyBulkUpdateToCrdt, getValueFromCrdt, doCompact } from './crdt-helpers';
export class CRDT {
    name;
    opts = {};
    ready;
    blocks;
    indexBlocks;
    indexers = new Map();
    _head = [];
    constructor(name, opts) {
        this.name = name || null;
        this.opts = opts || this.opts;
        this.blocks = new TransactionBlockstore(name, this.opts);
        this.indexBlocks = new IndexBlockstore(name ? name + '.idx' : undefined, this.opts);
        this.ready = this.blocks.ready.then((header) => {
            // @ts-ignore
            if (header.indexes)
                throw new Error('cannot have indexes in crdt header');
            if (header.head) {
                this._head = header.head;
            } // todo multi head support here
        });
    }
    async bulk(updates, options) {
        await this.ready;
        const tResult = await this.blocks.transaction(async (tblocks) => {
            const { head } = await applyBulkUpdateToCrdt(tblocks, this._head, updates, options);
            this._head = head; // we need multi head support here if allowing calls to bulk in parallel
            return { head };
        });
        return tResult;
    }
    // async getAll(rootCache: any = null): Promise<{root: any, cids: CIDCounter, clockCIDs: CIDCounter, result: T[]}> {
    async get(key) {
        await this.ready;
        const result = await getValueFromCrdt(this.blocks, this._head, key);
        if (result.del)
            return null;
        return result;
    }
    async changes(since = []) {
        await this.ready;
        return await clockChangesSince(this.blocks, this._head, since);
    }
    async compact() {
        await this.ready;
        return await doCompact(this.blocks, this._head);
    }
}
